export const IndianNames = [
  "Aarav",
  "Aditi",
  "Advait",
  "Aishwarya",
  "Akshay",
  "Amara",
  "Ananya",
  "Arjun",
  "Avani",
  "Ayush",
  "Bhavya",
  "Dev",
  "Divya",
  "Eesha",
  "Eshan",
  "Gaurav",
  "Gayatri",
  "Harsh",
  "Ishaan",
  "Jaya",
  "Kavya",
  "Krish",
  "Ojas",
  "Pooja",
  "Pranav",
  "Rahul",
  "Ria",
  "Rohan",
  "Sanya",
  "Shiv",
  "Sneha",
  "Surya",
  "Tanvi",
  "Tejas",
  "Trisha",
  "Uday",
  "Vaishnavi",
  "Varun",
  "Yash",
  "Zara",
  "Aditya",
  "Aisha",
  "Arnav",
  "Ayesha",
  "Dhruv",
  "Ishita",
  "Riya",
  "Shreya",
  "Aryan",
  "Ishani",
  "Kavita",
  "Nandini",
  "Raj",
  "Samira",
  "Shivani",
  "Tanu",
  "Vivek",
  "Yamini",
  "Anita",
  "Ashwin",
  "Neel",
  "Priya",
  "Ravi",
  "Yogita",
  "Zain",
];

export const DAILY_LIMIT = 10;
export const AI_NUMBER_OF_MOVES_TO_CHECK = 3;
export const AI_COMPUTER_ID = "computer";

export const MATRIX = [
  [
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FGreenLotus.jpg?alt=media&token=68d81528-76e3-4bde-938f-10597dc37e7f",
      isImage: true,
    },
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FGreenLotus.jpg?alt=media&token=68d81528-76e3-4bde-938f-10597dc37e7f",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeDaisy.jpg?alt=media&token=84d07cab-5cf2-4828-8a16-cf68e17b8334",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeDaisy.jpg?alt=media&token=84d07cab-5cf2-4828-8a16-cf68e17b8334",
      isImage: true,
    },
  ],
  [
    {
      id: 3,
      content:
      "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeTulip.png?alt=media&token=4eace1d9-db35-427d-a94b-02207486465c",
      isImage: true,
    },
    {
      id: 3,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeTulip.png?alt=media&token=4eace1d9-db35-427d-a94b-02207486465c",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkDaisy.jpg?alt=media&token=f354192a-6b77-44fd-8699-72af3546862d",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkDaisy.jpg?alt=media&token=f354192a-6b77-44fd-8699-72af3546862d",
      isImage: true,
    },
  ],
  [
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkRose.png?alt=media&token=880af277-7f52-4a31-84cc-7086f4de7c16",
      isImage: true,
    },
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkRose.png?alt=media&token=880af277-7f52-4a31-84cc-7086f4de7c16",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPurpleTulip.png?alt=media&token=914c8cb6-67df-4844-9eae-bca786240b35",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPurpleTulip.png?alt=media&token=914c8cb6-67df-4844-9eae-bca786240b35",
      isImage: true,
    },
  ],
  [
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedRose.png?alt=media&token=47d05900-7250-4538-ad88-90d6638c2d40",
      isImage: true,
    },
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedRose.png?alt=media&token=47d05900-7250-4538-ad88-90d6638c2d40",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedTulip.png?alt=media&token=a77ea9dd-e706-4153-abe8-f15974c90b24",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedTulip.png?alt=media&token=a77ea9dd-e706-4153-abe8-f15974c90b24",
      isImage: true,
    },
   
  ],
];

export const MATRIX_PRO = [
  [
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FGreenLotus.jpg?alt=media&token=68d81528-76e3-4bde-938f-10597dc37e7f",
      isImage: true,
    },
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FGreenLotus.jpg?alt=media&token=68d81528-76e3-4bde-938f-10597dc37e7f",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeDaisy.jpg?alt=media&token=84d07cab-5cf2-4828-8a16-cf68e17b8334",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeDaisy.jpg?alt=media&token=84d07cab-5cf2-4828-8a16-cf68e17b8334",
      isImage: true,
    },
  ],
  [
    {
      id: 3,
      content:
      "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeTulip.png?alt=media&token=4eace1d9-db35-427d-a94b-02207486465c",
      isImage: true,
    },
    {
      id: 3,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FOrangeTulip.png?alt=media&token=4eace1d9-db35-427d-a94b-02207486465c",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkDaisy.jpg?alt=media&token=f354192a-6b77-44fd-8699-72af3546862d",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkDaisy.jpg?alt=media&token=f354192a-6b77-44fd-8699-72af3546862d",
      isImage: true,
    },
  ],
  [
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkRose.png?alt=media&token=880af277-7f52-4a31-84cc-7086f4de7c16",
      isImage: true,
    },
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPinkRose.png?alt=media&token=880af277-7f52-4a31-84cc-7086f4de7c16",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPurpleTulip.png?alt=media&token=914c8cb6-67df-4844-9eae-bca786240b35",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FPurpleTulip.png?alt=media&token=914c8cb6-67df-4844-9eae-bca786240b35",
      isImage: true,
    },
  ],
  [
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedRose.png?alt=media&token=47d05900-7250-4538-ad88-90d6638c2d40",
      isImage: true,
    },
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedRose.png?alt=media&token=47d05900-7250-4538-ad88-90d6638c2d40",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedTulip.png?alt=media&token=a77ea9dd-e706-4153-abe8-f15974c90b24",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FRedTulip.png?alt=media&token=a77ea9dd-e706-4153-abe8-f15974c90b24",
      isImage: true,
    },
   
  ],
  [
    {
      id: 9,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FWhiteDaisy.jpg?alt=media&token=5972f18a-edd4-46f2-9199-37db17447293",
      isImage: true,
    },
    {
      id: 9,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FWhiteDaisy.jpg?alt=media&token=5972f18a-edd4-46f2-9199-37db17447293",
      isImage: true,
    },
    {
      id: 10,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FWhiteTulip.png?alt=media&token=f42f348f-baf2-4682-a003-1b158388d5e2",
      isImage: true,
    },
    {
      id: 10,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FWhiteTulip.png?alt=media&token=f42f348f-baf2-4682-a003-1b158388d5e2",
      isImage: true,
    },
   
  ],
  [
    {
      id: 11,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FYellowLotus.jpg?alt=media&token=645349e7-688e-492d-a382-7cf3353ee44b",
      isImage: true,
    },
    {
      id: 11,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FYellowLotus.jpg?alt=media&token=645349e7-688e-492d-a382-7cf3353ee44b",
      isImage: true,
    },
    {
      id: 12,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FYellowRose.png?alt=media&token=c78e902b-734d-4466-a92e-55a7b06f355a",
      isImage: true,
    }, {
      id: 12,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck3%2FYellowRose.png?alt=media&token=c78e902b-734d-4466-a92e-55a7b06f355a",
      isImage: true,
    },
  ]
];



export const MATRIX_TOURNAMENT_ROUND = [
  [
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%201.png?alt=media&token=9fb271b4-f445-411d-887d-8e8bf137b3b0",
      isImage: true,
    },
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%201.png?alt=media&token=9fb271b4-f445-411d-887d-8e8bf137b3b0",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%202.png?alt=media&token=310d0f83-e972-4317-b2af-5c8b564534e6",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%202.png?alt=media&token=310d0f83-e972-4317-b2af-5c8b564534e6",
      isImage: true,
    },
  ],
  [
    {
      id: 3,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%203.png?alt=media&token=4b99cd17-8a28-43d0-957b-c82d0d4183e1",
      isImage: true,
    },
    {
      id: 3,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%203.png?alt=media&token=4b99cd17-8a28-43d0-957b-c82d0d4183e1",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%204.png?alt=media&token=f3128e96-55f4-4725-bd48-702391edb18d",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%204.png?alt=media&token=f3128e96-55f4-4725-bd48-702391edb18d",
      isImage: true,
    },
  ],
  [
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%205.png?alt=media&token=8f6a206c-cd0a-4a7a-b45e-bd04a07accbd",
      isImage: true,
    },
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%205.png?alt=media&token=8f6a206c-cd0a-4a7a-b45e-bd04a07accbd",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%206.png?alt=media&token=42616e06-8602-43f1-89eb-f82f4eb69d6a",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%206.png?alt=media&token=42616e06-8602-43f1-89eb-f82f4eb69d6a",
      isImage: true,
    },
  ],
  [
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%207.png?alt=media&token=4edc63a2-75bb-47b4-b370-3cabe2732e9c",
      isImage: true,
    },
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%207.png?alt=media&token=4edc63a2-75bb-47b4-b370-3cabe2732e9c",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%208.png?alt=media&token=57d14667-f89b-4008-af91-fa58856a9385",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%208.png?alt=media&token=57d14667-f89b-4008-af91-fa58856a9385",
      isImage: true,
    },
  ],
];

export const MATRIX_PRO_TOURNAMENT_ROUND = [
  [
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%201.png?alt=media&token=9fb271b4-f445-411d-887d-8e8bf137b3b0",
      isImage: true,
    },
    {
      id: 1,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%201.png?alt=media&token=9fb271b4-f445-411d-887d-8e8bf137b3b0",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%202.png?alt=media&token=310d0f83-e972-4317-b2af-5c8b564534e6",
      isImage: true,
    },
    {
      id: 2,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%202.png?alt=media&token=310d0f83-e972-4317-b2af-5c8b564534e6",
      isImage: true,
    },
  ],
  [
    {
      id: 3,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%203.png?alt=media&token=4b99cd17-8a28-43d0-957b-c82d0d4183e1",
      isImage: true,
    },
    {
      id: 3,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%203.png?alt=media&token=4b99cd17-8a28-43d0-957b-c82d0d4183e1",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%204.png?alt=media&token=f3128e96-55f4-4725-bd48-702391edb18d",
      isImage: true,
    },
    {
      id: 4,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%204.png?alt=media&token=f3128e96-55f4-4725-bd48-702391edb18d",
      isImage: true,
    },
  ],
  [
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%205.png?alt=media&token=8f6a206c-cd0a-4a7a-b45e-bd04a07accbd",
      isImage: true,
    },
    {
      id: 5,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%205.png?alt=media&token=8f6a206c-cd0a-4a7a-b45e-bd04a07accbd",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%206.png?alt=media&token=42616e06-8602-43f1-89eb-f82f4eb69d6a",
      isImage: true,
    },
    {
      id: 6,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%206.png?alt=media&token=42616e06-8602-43f1-89eb-f82f4eb69d6a",
      isImage: true,
    },
  ],
  [
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%207.png?alt=media&token=4edc63a2-75bb-47b4-b370-3cabe2732e9c",
      isImage: true,
    },
    {
      id: 7,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%207.png?alt=media&token=4edc63a2-75bb-47b4-b370-3cabe2732e9c",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%208.png?alt=media&token=57d14667-f89b-4008-af91-fa58856a9385",
      isImage: true,
    },
    {
      id: 8,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%208.png?alt=media&token=57d14667-f89b-4008-af91-fa58856a9385",
      isImage: true,
    },
  ],
  [
    {
      id: 9,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%209.png?alt=media&token=5d7d8f33-d041-42e5-bef3-3b2040e04599",
      isImage: true,
    },
    {
      id: 9,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%209.png?alt=media&token=5d7d8f33-d041-42e5-bef3-3b2040e04599",
      isImage: true,
    },
    {
      id: 10,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%2010.png?alt=media&token=341c2ebc-dbac-4ccb-9805-80b93154d716",
      isImage: true,
    },
    {
      id: 10,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%2010.png?alt=media&token=341c2ebc-dbac-4ccb-9805-80b93154d716",
      isImage: true,
    },
  ],
  [
    {
      id: 11,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%2011.png?alt=media&token=e8b88f75-b7d3-4ad6-8dc6-8f722f58fa89",
      isImage: true,
    },
    {
      id: 11,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%2011.png?alt=media&token=e8b88f75-b7d3-4ad6-8dc6-8f722f58fa89",
      isImage: true,
    },
    {
      id: 12,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%2012.png?alt=media&token=2cfb8988-ed2d-4b5c-871b-b71525f9e5e4",
      isImage: true,
    },
    {
      id: 12,
      content:
        "https://firebasestorage.googleapis.com/v0/b/maidaan-921e1.appspot.com/o/Memory%20Cards%2FPro%20Deck%202%2FBio%20Icon%2012.png?alt=media&token=2cfb8988-ed2d-4b5c-871b-b71525f9e5e4",
      isImage: true,
    },
  ],
];

export const IndianStates = [
  "Delhi",
  "Pune",
  "Chandigarh",
  "Bengaluru",
  "Kolkata",
  "Mumbai",
  "Raichur",
  "Nagur",
  "Chennai",
  "Ahmedabad",
  "Indore",
  "Jaipur",
  "Lucknow",
  "Goa",
  "Shillong",
  "Patna",
  "Vishakhapatnam",
  "Bhopal",
  "Surat",
  "Meerut",
  "Agra",
  "Shimla",
  "Ludhiana",
  "Ambala",
  "Mysuru",
  "Coimbatore",
  "Thiruvanathapuram",
  "Kochi",
  "Hyderabad",
  "Noida",
  "Guntur",
  "Vijayawada",
  "Nashik",
  "Raipur",
  "Ranchi",
  "Jammu",
  "Aurangabad",
  "Alwar",
  "Cuttack",
  "Bhubaneswar",
  "Bargarh",
  "Silchar"
];

export const getRandomValueFromArray = (array) => {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
}
